<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8" id="main">
                    <div id="page-selector" class="page-selector row py-4 py-lg-5 justify-content-center">
                        <div class="page-tab col" id="profile">
                            <router-link :to="'/relation/' + title + '/profile'">简介</router-link>
                        </div>
                        <div class="page-tab col" id="gallery">
                            <router-link :to="'/relation/' + title + '/gallery'">图库</router-link>
                        </div>
                    </div>
                    <router-view :subtitle="subtitle" :charas="charas" :relationList="relation[4]" />
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import service from '../utils/request'
import { useCache } from '../utils/usecache'

let route = useRoute()
const title = route.params.title[0]
const subtitle = ref()
let router = useRouter()
const relation_list = ref([])
const relation = ref([])
const current_page_name = router.currentRoute.value.name
const charas = ref([])

watch(
    () => router.currentRoute.value.name,
    (newValue, oldValue) => {
        if (newValue != oldValue) {
            var new_page = '#' + newValue
            var old_page = '#' + oldValue
            $(new_page).removeClass('page-tab')
            $(new_page).addClass('page-tab-selected')
            $(old_page).removeClass('page-tab-selected')
            $(old_page).addClass('page-tab')
        }
    }
)

const getRelation = (title) => {
    var api = '/user/relation/list'
    service.get(api).then(res => {
        relation_list.value = res.data.find(relation => relation.title === title);
        relation.value = Object.values(relation_list.value).slice(2);
        if (!relation.value[2]) {
            subtitle.value = relation.value[0] + "&" + relation.value[1]
        } else if (relation.value[2] && !relation.value[3]) {
            subtitle.value = relation.value[0] + "&" + relation.value[1] + "&" + relation.value[2]
        } else if (relation.value[3]) {
            subtitle.value = relation.value[0] + "&" + relation.value[1] + "&" + relation.value[2] + "&" + relation.value[3]
        }
    })
        .catch(err => {
            console.log(err)
        })
}

onMounted(() => {
    var current_page = '#' + current_page_name
    $(current_page).removeClass('page-tab')
    $(current_page).addClass('page-tab-selected')
    getRelation(title);
})


watch(
    () => router.currentRoute.value.name,
    (newValue, oldValue) => {
        if (newValue != oldValue) {
            var new_page = '#' + newValue
            var old_page = '#' + oldValue
            $(new_page).removeClass('page-tab')
            $(new_page).addClass('page-tab-selected')
            $(old_page).removeClass('page-tab-selected')
            $(old_page).addClass('page-tab')
        }
    }
)


</script>
<style scoped>
.page-tab {
    float: left;
    border-top-left-radius: 12px;
    -webkit-border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    -webkit-border-top-right-radius: 12px;
    border-bottom-left-radius: 2px;
    -webkit-border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-border-bottom-right-radius: 2px;
    padding: 0.5rem;
    background-color: skyblue;
    text-align: center;
    margin-right: 4px;
}

.page-tab a {
    color: white;
}

.page-tab:hover {
    background-color: rgba(135, 206, 235, 0.2);
}

.page-tab:hover a {
    color: skyblue;
}

.page-tab-selected {
    float: left;
    border-top-left-radius: 12px;
    -webkit-border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    -webkit-border-top-right-radius: 12px;
    border-bottom-left-radius: 2px;
    -webkit-border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-border-bottom-right-radius: 2px;
    padding: 0.5rem;
    background-color: MediumTurquoise;
    text-align: center;
    margin-right: 4px;
}

.page-tab-selected a {
    color: white;
}

.info {
    background-color: white;
    padding: 2%;
}
</style>
